import React from "react";
import "./UpdateHistoryItem.css";
import { HistoryEntry, HistoryActionType } from "winslow-core";
import { MyTooltip } from "../../common/MyTooltip";

export interface UpdateHistoryItemProps {
  history: HistoryEntry;
}

export const UpdateHistoryItem: React.FC<UpdateHistoryItemProps> = ({
  history,
}) => {
  return (
    <>
      {history.actionType === HistoryActionType.CREATE_FROM_TYPE && (
        <MyTooltip title={history.actionValue}>
          <div
            className="update-history-item"
            style={{ borderColor: "#ff543d" }}>
            <img
              src="./icons/policy-studio-file-icon.svg"
              alt=""
              className="update-history-item-icon"
              loading="lazy"
            />
            <div className="update-history-item-title">
              First draft of policy created.
            </div>
          </div>
        </MyTooltip>
      )}
      {history.actionType === HistoryActionType.CREATE_FROM_FILE && (
        <MyTooltip title={history.actionValue}>
          <div
            className="update-history-item"
            style={{ borderColor: "#ff543d" }}>
            <img
              src="./icons/policy-studio-file-icon.svg"
              alt=""
              className="update-history-item-icon"
              loading="lazy"
            />
            <div className="update-history-item-title">
              First draft of policy from file upload.
            </div>
          </div>
        </MyTooltip>
      )}
      {history.actionType === HistoryActionType.CREATE_FROM_LINK_RECORD && (
        <MyTooltip title={history.actionValue}>
          <div
            className="update-history-item"
            style={{ borderColor: "#ff543d" }}>
            <img
              src="./icons/policy-studio-file-icon.svg"
              alt=""
              className="update-history-item-icon"
              loading="lazy"
            />
            <div className="update-history-item-title">
              First draft of policy from resource.
            </div>
          </div>
        </MyTooltip>
      )}
      {history.actionType === HistoryActionType.ADJUSTMENT_UPDATE && (
        <MyTooltip title={history.actionValue}>
          <div
            className="update-history-item"
            style={{ borderColor: "#ff543d" }}>
            <img
              src="./icons/policy-studio-file-icon.svg"
              alt=""
              className="update-history-item-icon"
              loading="lazy"
            />
            <div className="update-history-item-title">
              {history.actionName}
            </div>
          </div>
        </MyTooltip>
      )}
      {history.actionType === HistoryActionType.ADJUSTMENT_REVERT && (
        <MyTooltip title={history.actionValue}>
          <div
            className="update-history-item"
            style={{ borderColor: "#ff543d" }}>
            <img
              src="./icons/policy-studio-file-icon.svg"
              alt=""
              className="update-history-item-icon"
              loading="lazy"
            />
            <div className="update-history-item-title">
              Reverted: {history.actionName}
            </div>
          </div>
        </MyTooltip>
      )}
      {history.actionType === HistoryActionType.PROMPT_UPDATE && (
        <div
          className="update-history-prompt"
          style={{ borderColor: "#ff543d" }}>
          <div className="update-history-prompt-value">
            {history.actionValue}
          </div>
        </div>
      )}
      {history.actionType === HistoryActionType.CONTENT_UPDATE && (
        <MyTooltip title={history.actionValue}>
          <div
            className="update-history-prompt"
            style={{ borderColor: "#ff543d" }}>
            <div className="update-history-prompt-value">
              {history.actionName}
            </div>
          </div>
        </MyTooltip>
      )}
    </>
  );
};

export default UpdateHistoryItem;
